<template>
  <dl :class="$style.row">
    <dt :class="[$style.row__title, $style.title]">
      <span :class="$style.text">{{ name }}</span>

      <span :class="$style.title__poptip">
        <slot name="poptip" />
      </span>
    </dt>

    <dd :class="[$style.row__value, $style.value]">
      <slot v-if="!isEditing || $slots.editor === undefined" />
      <slot v-else name="editor" />
      <div v-if="$slots.rowAfter">
        <slot name="rowAfter" />
      </div>
    </dd>
  </dl>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    name: string
    isEditing?: boolean
  }>(),
  {
    isEditing: false,
  }
)
</script>

<style lang="scss" module>
.row {
  display: flex;
  border-radius: $border-radius-v2-base;
  border: 1px solid $color-border-low-emphasis;

  &__title {
    height: 100%;
    width: 250px;
  }

  &__value {
    flex: 1;
  }
}

.title {
  display: flex;
  align-items: center;
  background-color: $color-background-base;
  padding: 0 0 0 24px;

  &__poptip {
    padding-top: 6px;
    margin-left: 8px;
  }
}

.text {
  font-size: 16px;
  font-weight: 700;
}

.value {
  padding: 24px;
}
</style>
